import React from "react";
import { FaQuoteLeft } from "react-icons/fa";
import profile1 from "../assets/profile-1.jpg";
import profile2 from "../assets/profile-2.jpg";
const Testimonial = () => {
  const testimonials = [
    {
      name: "WILLIAMSON",
      role: "WEB DEVELOPER",
      image: profile1,
      text: " Lorem ipsum dolor sit amet, consectetur adipiscing elit .Curabitur tempor finibus risus. Vivamus quis aliquet nibh.Nunc vitae felis nunc. Nam scelerisque maximus tempor. Proinsed euismod tellus. Nunc sodales, quam et porttitor accumsan,lectus dolor laoreet dolor, a scelerisque.",
    },
    {
      name: "kristiana ",
      role: "Web Designer",
      image: profile2,
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tempor finibus risus. Vivamus quis aliquet nibh. Nunc vitae felis nunc. Nam scelerisque maximus tempor. Proin sed euismod tellus. Nunc sodales, quam et porttitor accumsan, lectus dolor laoreet dolor, a scelerisque.",
    },
    {
      name: "Steve Thomas ",
      role: "Web Developer",
      image: profile1,
      text: " Lorem ipsum dolor sit amet, consectetur adipiscing elit .Curabitur tempor finibus risus. Vivamus quis aliquet nibh.Nunc vitae felis nunc. Nam scelerisque maximus tempor. Proinsed euismod tellus. Nunc sodales, quam et porttitor accumsan,lectus dolor laoreet dolor, a scelerisque.",
    },
  ];

  return (
    <div
      id="carouselExample"
      className="carousel slide col-lg-6 bg-image position-relative"
      data-bs-ride="carousel"
    >
      <div className="carousel-inner overlay-content text-white p-4 text-center">
        {testimonials.map((testimonial, index) => (
          <div
            key={index}
            className={`carousel-item ${index === 0 ? "active" : "" }`}
          >
            <div className="imagediv">
              <img
                src={testimonial.image}
                className="d-block testimonial-img rounded-circle"
                alt={testimonial.name}
              />
            </div>
            <p className="testimonial-text mt-3">{testimonial.text}</p>
            <h6 className="mt-3 testimonial-name">
              {testimonial.name} - {testimonial.role}
            </h6>
            <FaQuoteLeft size={30} color="#00aaff" className="mt-3" />
          </div>
        ))}
      </div>
{/* 
      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#carouselExample"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#carouselExample"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button> */}
    </div>
  );
};

export default Testimonial;
